import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { cloneDeep, union } from 'lodash';
import {
  house_captain_incharge,
  house_teacher,
} from 'src/app/shared/models/house.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { SchoolHouseService } from 'src/app/shared/services/school-house.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { SchoolHousesState } from 'src/app/shared/store/schoolhouses/school-house.state';

@Component({
  selector: 'app-house-teachers-list-dialog',
  templateUrl: './house-teachers-list-dialog.component.html',
  styleUrls: ['./house-teachers-list-dialog.component.scss'],
})
export class HouseTeachersListDialogComponent implements OnInit {
  schoolTeacherList: any[] = [];
  displayTeachersList: any[] = [];
  selectedTeachersArray: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private store: Store,
    private commonSrvc_: CommonService,
    private schoolHouseSrvc_: SchoolHouseService,
    private snackBarSrvc_: SnackbarService,
    private dialogSrvc_: DialogService,
    private router: Router
  ) {}

  ngOnInit(): void {
    console.log(this.data);
    this.store
      .select(SchoolHousesState.getSchoolTeachers)
      .subscribe((el: any) => {
        this.schoolTeacherList = cloneDeep(el);
        this.displayTeachersList = this.schoolTeacherList.filter(
          (teacher: any) => {
            if (!teacher.hasOwnProperty('house_id') || teacher.house_id == '') {
              return teacher;
            }
          }
        );
        console.log(this.displayTeachersList);
      });
  }

  popPushIncharge(id: string) {
    if (this.selectedTeachersArray.length >= 1) {
      this.selectedTeachersArray = [];
    }
    this.selectedTeachersArray.push(id);
  }

  popPushTeacher(id: string) {
    if (this.selectedTeachersArray.includes(id)) {
      let index = this.selectedTeachersArray.findIndex(
        (tid: string) => tid == id
      );
      this.selectedTeachersArray.splice(index, 1);
    } else {
      this.selectedTeachersArray.push(id);
      this.selectedTeachersArray = union(this.selectedTeachersArray);
    }
    console.log(this.selectedTeachersArray);
  }

  onSavingTeachers() {
    let teachers: house_teacher[] = [];
    for (let i = 0; i < this.selectedTeachersArray.length; i++) {
      const teacherDocId = this.selectedTeachersArray[i];
      let teacher = this.schoolTeacherList.find(
        (teacher: any) => teacher.id == teacherDocId
      );
      if (!!teacher) {
        let houseTeacher: house_teacher = {
          doc_id: teacherDocId,
          uid: teacher.user_id,
        };
        teachers.push(houseTeacher);
      }
    }

    console.log(teachers);

    this.commonSrvc_.showSpinner = true;
    this.schoolHouseSrvc_
      .updateTeachersArrayInHouseDoc(this.data.id, teachers)
      .then(() => {
        this.snackBarSrvc_.openSnackBarTop(
          'Teachers updated in house document',
          'Success'
        );
        this.schoolHouseSrvc_
          .updateMultipleTeacherDocs(this.selectedTeachersArray, this.data.id)
          .then(() => {
            this.commonSrvc_.showSpinner = false;
            this.snackBarSrvc_.openSnackBarTop(
              `Teacher docs updated successfully`,
              'Success'
            );
            this.dialogSrvc_.close();
          })
          .catch((err) => {
            this.commonSrvc_.showSpinner = false;
            this.snackBarSrvc_.openSnackBarTop(
              `Error in updation of teacher docs due to ${err}`,
              'Failure'
            );
          });
      })
      .catch((err: any) => {
        this.commonSrvc_.showSpinner = false;
        this.snackBarSrvc_.openSnackBarTop(
          `Document updation failed due to ${err}`,
          'Failure'
        );
      });
  }

  onSavingIncharge() {
    let teacher = this.schoolTeacherList.find(
      (teacher: any) => teacher.id == this.selectedTeachersArray[0]
    );
    let houseIncharge: house_captain_incharge = {
      doc_id: this.selectedTeachersArray[0],
      role: this.data.role.toLowerCase(),
      uid: teacher.user_id,
    };
    console.log(houseIncharge);
    if (this.data.action == 'add') {
      this.commonSrvc_.showSpinner = true;
      this.schoolHouseSrvc_
        .addInchargeToHouseDoc(this.data.id, houseIncharge)
        .then(() => {
          this.snackBarSrvc_.openSnackBarTop(
            'Incharge added successfully to house doc',
            'Success'
          );
          this.schoolHouseSrvc_
            .updateTeacherDoc(houseIncharge.doc_id, this.data.id)
            .then(() => {
              this.snackBarSrvc_.openSnackBarTop(
                'Teacher Document updated successfully',
                'Success'
              );
              this.commonSrvc_.showSpinner = false;
              this.dialogSrvc_.close();
              this.router.navigate([`layout/community/house/list`]);
            })
            .catch(() => {
              this.snackBarSrvc_.openSnackBar(
                'Teacher document updation failed',
                'Failure'
              );
              this.commonSrvc_.showSpinner = false;
            });
        })
        .catch(() => {
          this.snackBarSrvc_.openSnackBar(
            'Incharge addition failed',
            'Failure'
          );
          this.commonSrvc_.showSpinner = false;
        });
    } else if (this.data.action == 'edit') {
      this.commonSrvc_.showSpinner = true;
      console.log(this.data.incharges);
      let house_incharges = this.data.incharges;
      house_incharges = house_incharges.map((hIncharge: any) => {
        let obj: house_captain_incharge = {
          doc_id: hIncharge.doc_id,
          role: hIncharge.role.toLowerCase(),
          uid: hIncharge.uid,
        };
        return obj;
      });
      let index = house_incharges.findIndex(
        (hIn: any) => hIn.doc_id == this.data.incharge_doc_id
      );
      house_incharges.splice(index, 1, houseIncharge);
      this.schoolHouseSrvc_
        .updateTeacherDoc(this.data.incharge_doc_id, '')
        .then(() => {
          this.snackBarSrvc_.openSnackBarTop(
            'Teacher Document has been updated successfully',
            'Success'
          );
          this.schoolHouseSrvc_
            .updateInchargesArrayInHouseDoc(house_incharges, this.data.id)
            .then(() => {
              this.snackBarSrvc_.openSnackBarTop(
                'Incharges array has been updated successfully',
                'Success'
              );
              this.schoolHouseSrvc_
                .updateTeacherDoc(this.selectedTeachersArray[0], this.data.id)
                .then(() => {
                  this.snackBarSrvc_.openSnackBar(
                    'Teacher Document has been updated successfully',
                    'Success'
                  );
                  this.commonSrvc_.showSpinner = false;
                  this.dialogSrvc_.close();
                  this.router.navigate([`layout/community/house/list`]);
                })
                .catch(() => {
                  this.snackBarSrvc_.openSnackBarTop(
                    'Teacher Document updation failed',
                    'Failure'
                  );
                  this.commonSrvc_.showSpinner = false;
                });
            })
            .catch(() => {
              this.snackBarSrvc_.openSnackBarTop(
                'Incharges array updation failed',
                'Failure'
              );
              this.commonSrvc_.showSpinner = false;
            });
        })
        .catch(() => {
          this.snackBarSrvc_.openSnackBarTop(
            'Teacher Document updation failed',
            'Failure'
          );
          this.commonSrvc_.showSpinner = false;
        });
    }
  }
}
